import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { MultiStepLeadForm } from "./MultiStepLeadForm";
import { useLeadModal } from "../../context/LeadModalContext";
import { useNavigate } from "react-router-dom";

export function LeadModal() {
	const { open, prefill, closeLeadModal } = useLeadModal();
	const navigate = useNavigate();

	return (
		<Dialog open={open} onOpenChange={(o) => !o && closeLeadModal()}>
			<DialogContent
				className="max-w-lg p-0 overflow-hidden gap-0 border-slate-200 dark:border-slate-700"
				data-testid="lead-modal"
			>
				<DialogTitle className="sr-only">Free Growth Consultation</DialogTitle>
				<DialogDescription className="sr-only">
					Answer four quick steps to request a free school growth consultation.
				</DialogDescription>
				<div className="bg-gradient-to-br from-emerald-600 to-teal-700 px-6 py-5 text-white">
					<p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-100">
						Free Growth Consultation
					</p>
					<h3 className="font-heading text-2xl font-extrabold mt-1">
						Let's grow your school.
					</h3>
					<p className="text-sm text-emerald-50/90 mt-1">
						Answer 4 quick steps. A Senior Education Consultant will reach out.
					</p>
				</div>
				<div className="px-6 py-6 max-h-[70vh] overflow-y-auto">
					<MultiStepLeadForm
						embedded
						sourcePage={prefill.sourcePage || "Homepage"}
						defaultRequirement={prefill.requirement || ""}
						onDone={closeLeadModal}
						onExplore={() => { closeLeadModal(); navigate("/#services"); }}
					/>
				</div>
			</DialogContent>
		</Dialog>
	);
}
